function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as SessionApi from "../ajax/SessionApi";
import QRCode from "qrcode.react";
import SwipeableViews from 'react-swipeable-views';
import Pagination from '../commons/Pagination';
import IntlMessage from '../commons/Intl';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { locales } from '../commons/Intl';
import { Action, Errors, Label, Placeholder, SphereCast, SphereCastView, Streaming, StreamingSituations } from "../commons/IntlMessages";
import { StreamingStatuses } from "../enum/StreamingStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var messages = locales[language];
var styles = {
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff'
  },
  slide1: {},
  slide2: {},
  slide3: {},
  slide4: {},
  slide5: {},
  slide6: {},
  slide7: {}
}; // SphereCast

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 生成
   */

  Mode[Mode["Generate"] = 1] = "Generate";
  /**
   * 配信
   */

  Mode[Mode["Streaming"] = 2] = "Streaming";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      SphereCastViewMode: Mode.None,
      Streamings: [],
      StreamingLocation: "",
      Selected: null,
      ActiveIndex: 0,
      MonthlyTotalUpTime: "",
      MonthlyLimitUpTime: "",
      CanStreaming: false,
      IsMyMeeting: false,
      IsProcessing: false,
      Messages: [],
      ErrorMessages: []
    };

    _this.getSession(_this.props.sessionId, function () {});

    return _this;
  }
  /**
   * 会議情報を取得します。
   *
   * @param session 会議情報
   */


  _createClass(MainComponent, [{
    key: "getSession",
    value: function getSession(sessionId, callback) {
      var _this2 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        Messages: [],
        ErrorMessages: []
      });
      SessionApi.QueryDetail(sessionId, false, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
        var limitSeconds = data.Sessions.MonthlyLimitUpTime;
        var limitHours = Math.floor(data.Sessions.MonthlyLimitUpTime / 3600);
        var limitMinutes = Math.floor((data.Sessions.MonthlyLimitUpTime - limitHours * 3600) / 60);
        var limitSeconds = data.Sessions.MonthlyLimitUpTime - limitHours * 3600 - limitMinutes * 60;
        var paddedLimitHours = ("00" + String(limitHours)).slice(-2);
        var paddedLimitMinutes = ("00" + String(limitMinutes)).slice(-2);
        var paddedLimitSeconds = ("00" + String(limitSeconds)).slice(-2);
        var seconds = data.Sessions.MonthlyLimitUpTime - data.Sessions.MonthlyTotalUpTime;
        var paddedHours = "00";
        var paddedMinutes = "00";
        var paddedSeconds = "00";

        if (seconds > 0) {
          var hours = Math.floor(seconds / 3600);
          var minutes = Math.floor((seconds - hours * 3600) / 60);
          var seconds = seconds - hours * 3600 - minutes * 60;
          paddedHours = ("00" + String(hours)).slice(-2);
          paddedMinutes = ("00" + String(minutes)).slice(-2);
          paddedSeconds = ("00" + String(seconds)).slice(-2);
        }

        var monthlyTotalUpTime = "".concat(paddedHours, ":").concat(paddedMinutes, ":").concat(paddedSeconds);
        var monthlyLimitUpTime = "".concat(paddedLimitHours, ":").concat(paddedLimitMinutes, ":").concat(paddedLimitSeconds);
        var canStreaming = data.Sessions.MonthlyTotalUpTime < data.Sessions.MonthlyLimitUpTime;
        var streamings = data.Detail.MaterialList.filter(function (m) {
          return m.IsStream;
        });

        _this2.setState({
          Streamings: streamings,
          MonthlyTotalUpTime: monthlyTotalUpTime,
          MonthlyLimitUpTime: monthlyLimitUpTime,
          CanStreaming: canStreaming,
          IsMyMeeting: data.Detail.IsMyMeeting,
          IsProcessing: false,
          Messages: [],
          ErrorMessages: []
        }, function () {
          if (streamings.length == 0) {
            _this2.openSphereCastModal();
          }

          if (callback != null) {
            callback();
          }
        });
      });
    }
    /**
     * 配信場所を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStreamingLocation",
    value: function updateStreamingLocation(e) {
      this.setState({
        StreamingLocation: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * SphereCastStreamingモーダルを表示のみで起動します。
     */

  }, {
    key: "openSphereCastStreamingModal",
    value: function openSphereCastStreamingModal(selected) {
      this.props.common.copyToClipboard(selected.StreamingUrl);
      this.state.Messages.push(intl.format(SphereCastView.CopyPublishLinkMessage));
      this.setState({
        Selected: selected,
        ActiveIndex: 0,
        IsProcessing: true,
        Messages: this.state.Messages,
        ErrorMessages: [],
        SphereCastViewMode: Mode.Streaming
      });
    }
    /**
     * ストリーミングを登録します。
     *
     * @param materialFileName マテリアル名
     */

  }, {
    key: "streamingSphereCast",
    value: function streamingSphereCast() {
      this.hiddenSphereCastStreamingModal();
    }
    /**
     * SphereCastStreamingモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSphereCastStreamingModal",
    value: function hiddenSphereCastStreamingModal() {
      this.setState({
        Selected: null,
        ActiveIndex: 0,
        IsProcessing: false,
        Messages: [],
        ErrorMessages: [],
        SphereCastViewMode: Mode.None
      });
    }
    /**
     * SphereCastモーダルを表示のみで起動します。
     */

  }, {
    key: "openSphereCastModal",
    value: function openSphereCastModal() {
      this.setState({
        IsProcessing: true,
        Messages: [],
        ErrorMessages: [],
        SphereCastViewMode: Mode.Generate
      });
    }
    /**
     * ストリーミングを登録します。
     *
     * @param materialFileName マテリアル名
     */

  }, {
    key: "entrySphereCast",
    value: function entrySphereCast(materialFileName) {
      var _this3 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        Messages: [],
        ErrorMessages: []
      });
      SessionApi.EntryStreaming(this.props.sessionId, materialFileName, function (data) {
        _this3.hiddenSphereCastModal();

        _this3.getSession(_this3.props.sessionId, function () {
          _this3.state.Messages.push(intl.format(SphereCastView.CreatePublishLinkMessage));

          _this3.setState({
            Messages: _this3.state.Messages,
            StreamingLocation: ""
          });
        });
      });
    }
    /**
     * ストリーミングを削除します。
     *
     * @param materialFileName マテリアル名
     */

  }, {
    key: "deleteSphereCast",
    value: function deleteSphereCast(materialFileName) {
      var _this4 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        Messages: [],
        ErrorMessages: []
      });
      var materials = [];
      materials.push(materialFileName);
      SessionApi.DeleteMaterial(this.props.sessionId, materials, function (data) {
        _this4.onDialogClose(true);

        _this4.getSession(_this4.props.sessionId, function () {
          _this4.state.Messages.push(intl.format(SphereCastView.RemovePublishLinkMessage));

          _this4.setState({
            Messages: _this4.state.Messages
          });
        });
      });
    }
    /**
     * SphereCastモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSphereCastModal",
    value: function hiddenSphereCastModal() {
      this.setState({
        IsProcessing: false,
        Messages: [],
        ErrorMessages: [],
        SphereCastViewMode: Mode.None,
        StreamingLocation: ""
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "entry",
    value: function entry() {
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var materialFileName = this.state.StreamingLocation + ".Stream";
        this.entrySphereCast(materialFileName);
      }
    }
    /**
     * 選択処理を行います。
     */

  }, {
    key: "select",
    value: function select(selected) {
      this.setState({
        Selected: selected
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDialogClose",
    value: function onDialogClose(clear) {
      var dialog = null;
      dialog = $("#SphereCastQrCodeModal");

      if (dialog) {
        dialog.modal('hide');
      }

      dialog = $("#SphereCastSettingModal");

      if (dialog) {
        dialog.modal('hide');
      }

      dialog = $("#SphereCastDeleteModal");

      if (dialog) {
        dialog.modal('hide');
      }

      dialog = $("#SphereCastHelpModal");

      if (dialog) {
        dialog.modal('hide');
      }

      dialog = $("#SphereCastEmptyModal");

      if (dialog) {
        dialog.modal('hide');
      }

      if (clear) {
        this.setState({
          Selected: null
        });
      }
    }
  }, {
    key: "GetStreamingStatus",
    value: function GetStreamingStatus(status) {
      switch (status) {
        case StreamingStatuses.Offline:
        case StreamingStatuses.Archive:
          return intl.format(StreamingSituations.Offline);

        case StreamingStatuses.Live:
          return intl.format(StreamingSituations.Live);

        default:
          return "";
      }
    }
    /**
     * ページ番号変更
     * @param pageNumber ページ番号
     */

  }, {
    key: "onHandleIndexChange",
    value: function onHandleIndexChange(index) {
      this.setState({
        ActiveIndex: index,
        Messages: index == 0 ? this.state.Messages : []
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement(IntlProvider, {
        locale: language,
        messages: messages
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, this.state.Messages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-messages"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.Messages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))))), /*#__PURE__*/React.createElement("div", {
        id: "content-main",
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 title__frame"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "mainIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_360streaming_grey.svg"
      }), /*#__PURE__*/React.createElement("h1", null, intl.format(SphereCast.Title)))), this.state.SphereCastViewMode == Mode.None && [/*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.NoneMessage, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko&hl=ja&gl=US&pli=1",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      }))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.NoneMessage, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://apps.apple.com/jp/app/insta360/id1491299654",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "line"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "content__list"
      }, this.state.Streamings != null && this.state.Streamings.length > 0 && this.state.Streamings.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.MaterialFileName,
          className: "content__item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content__top"
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, ("00" + String(_i + 1)).slice(-2), ".", x.DisplayMaterialFileName), /*#__PURE__*/React.createElement("div", {
          className: "statusCont statusCont__status__" + x.StreamingStatus.toString()
        }, /*#__PURE__*/React.createElement("div", {
          className: "statusCont__name"
        }, _this5.GetStreamingStatus(x.StreamingStatus)))), /*#__PURE__*/React.createElement("div", {
          className: "content__bottom"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content__bottom__left"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-primary openCont",
          onClick: _this5.openSphereCastStreamingModal.bind(_this5, x),
          tabIndex: -1
        }, /*#__PURE__*/React.createElement("img", {
          className: "openCont__icon",
          src: "/assets/img/Icon_CopyLink_White.svg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "openCont__name"
        }, intl.format(Action.CopyLink))), /*#__PURE__*/React.createElement("a", {
          href: "#",
          "data-toggle": "modal",
          "data-target": "#SphereCastQrCodeModal"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-normal qrCont",
          onClick: _this5.select.bind(_this5, x),
          tabIndex: -1
        }, /*#__PURE__*/React.createElement("img", {
          className: "qrCont__icon",
          src: "/assets/img/Icon_QR_Black.svg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "qrCont__name"
        }, intl.format(Action.QRDisplay))))), /*#__PURE__*/React.createElement("div", {
          className: "content_bottom_right"
        }, /*#__PURE__*/React.createElement("a", {
          href: "#",
          "data-toggle": "modal",
          "data-target": "#SphereCastSettingModal"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-normal settingCont",
          onClick: _this5.select.bind(_this5, x),
          tabIndex: -1
        }, /*#__PURE__*/React.createElement("img", {
          className: "settingCont__icon",
          src: "/assets/img/Icon_Setting_Black.svg"
        }))))));
      }))))], this.state.SphereCastViewMode == Mode.Generate && [/*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "imgCont__image",
        src: "/assets/img/Image_360Streaming.png"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "link__message"
      }, intl.format(SphereCastView.GenerateMessage))), this.state.CanStreaming && /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto center"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "StreamingLocation",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this5.updateStreamingLocation(e);
        },
        value: this.state.StreamingLocation,
        tabIndex: 101,
        placeholder: intl.format(Label.StreamingLocation) + "(" + intl.format(Placeholder.StreamingLocation) + ")"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "StreamingLocation",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), !this.state.CanStreaming && /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        style: {
          opacity: "0.5"
        },
        name: "StreamingLocation",
        id: "Name",
        disabled: true,
        value: intl.format(Streaming.StreamingWarning),
        tabIndex: 101
      })), /*#__PURE__*/React.createElement("div", {
        className: "main__footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "center",
        style: {
          display: "flex"
        }
      }, this.state.Streamings && this.state.Streamings.length > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "backButton",
        onClick: this.hiddenSphereCastModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "backText"
      }, "\u2190")), this.state.CanStreaming && this.state.StreamingLocation != "" && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary linkCont",
        onClick: this.entry.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "linkCont__icon",
        src: "/assets/img/Icon_CopyLink_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "linkCont__name"
      }, intl.format(Action.PublishLink))), !(this.state.CanStreaming && this.state.StreamingLocation != "") && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary linkCont",
        disabled: true,
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "linkCont__icon",
        src: "/assets/img/Icon_CopyLink_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "linkCont__name"
      }, intl.format(Action.PublishLink)))))], this.state.SphereCastViewMode == Mode.Streaming && [/*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement(SwipeableViews, {
        enableMouseEvents: true,
        index: this.state.ActiveIndex,
        onChangeIndex: this.onHandleIndexChange.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide1)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.TutorialMessage_01, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko&hl=ja&gl=US&pli=1",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      }))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.TutorialMessage_01, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://apps.apple.com/jp/app/insta360/id1491299654",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_01.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide2)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_02))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_02.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide3)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_03))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_03.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide4)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_04))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_04.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide5)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_05))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_05.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide6)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_06))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_06.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide7)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "notes__title"
      }, intl.format(SphereCastView.TutorialMessage_07_01)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_02)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_03)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_04)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_05)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_06)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_07))))), /*#__PURE__*/React.createElement(Pagination, {
        dots: 7,
        index: this.state.ActiveIndex,
        onChangeIndex: this.onHandleIndexChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "main__footer"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.hiddenSphereCastStreamingModal.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Close))), this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("a", {
        href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary appCont",
        onClick: this.streamingSphereCast.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "appCont__icon",
        src: "/assets/img/Icon_Open_Black.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "appCont__name"
      }, intl.format(SphereCastView.OpenInsta360App)))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("a", {
        href: "https://apps.apple.com/jp/app/insta360/id1491299654",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary appCont",
        onClick: this.streamingSphereCast.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "appCont__icon",
        src: "/assets/img/Icon_Open_Black.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "appCont__name"
      }, intl.format(SphereCastView.OpenInsta360App)))))]), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, this.state.SphereCastViewMode == Mode.None && /*#__PURE__*/React.createElement("div", {
        className: "center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "linkGenerateButton",
        onClick: this.openSphereCastModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "linkGenerateFrame"
      }, /*#__PURE__*/React.createElement("img", {
        className: "linkGenerateImage",
        src: "/assets/img/Icon_Add.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "linkGenerateText"
      }, intl.format(Action.GenerateLink)))), /*#__PURE__*/React.createElement("div", {
        className: "center"
      }, this.state.CanStreaming && /*#__PURE__*/React.createElement("label", {
        className: "footer__time"
      }, /*#__PURE__*/React.createElement("span", null, intl.format(Label.RemainingStreamingTime)), " : ", /*#__PURE__*/React.createElement("span", null, this.state.MonthlyTotalUpTime), " / ", /*#__PURE__*/React.createElement("span", null, this.state.MonthlyLimitUpTime)), !this.state.CanStreaming && /*#__PURE__*/React.createElement("label", {
        className: "footer__time"
      }, /*#__PURE__*/React.createElement("span", null, intl.format(Label.RemainingStreamingTime)), " : ", /*#__PURE__*/React.createElement("span", {
        style: {
          color: "red"
        }
      }, this.state.MonthlyTotalUpTime), " / ", /*#__PURE__*/React.createElement("span", null, this.state.MonthlyLimitUpTime)), this.state.CanStreaming && /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-toggle": "modal",
        "data-target": "#SphereCastHelpModal",
        className: "footer_info"
      }, /*#__PURE__*/React.createElement("img", {
        width: "16px",
        height: "16px",
        src: "/assets/img/Icon_Help_Circle_Black.svg"
      })), !this.state.CanStreaming && /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-toggle": "modal",
        "data-target": "#SphereCastEmptyModal",
        className: "footer_info"
      }, /*#__PURE__*/React.createElement("img", {
        width: "16px",
        height: "16px",
        src: "/assets/img/Icon_Help_Circle_Black.svg"
      })))), /*#__PURE__*/React.createElement("div", {
        id: "modalArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SphereCastQrCodeModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ms-auto center"
      }, this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.QrCodeModalMessage, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko&hl=ja&gl=US&pli=1",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      }))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.QrCodeModalMessage, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://apps.apple.com/jp/app/insta360/id1491299654",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-item"
      }, /*#__PURE__*/React.createElement(QRCode, {
        className: "modal-qrcode",
        value: this.props.host + "/spherecastlink/index/" + (this.state.Selected ? encodeURIComponent(btoa(this.state.Selected.StreamingUrl)) : ""),
        size: 120
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.onDialogClose.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Close))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SphereCastSettingModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("h3", null, this.state.Selected ? this.state.Selected.DisplayFileName : ""))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-itemTitle"
      }, intl.format(Label.StreamingStatus)), /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-itemValue"
      }, this.state.Selected ? this.GetStreamingStatus(this.state.Selected.StreamingStatus) : ""), /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-itemTitle"
      }, intl.format(Label.StreamingUrl)), /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-itemValue"
      }, this.state.Selected ? this.state.Selected.StreamingUrl : "")), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.onDialogClose.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Close))), this.state.IsMyMeeting && /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-toggle": "modal",
        "data-target": "#SphereCastDeleteModal"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default deleteCont",
        onClick: this.onDialogClose.bind(this, false),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "deleteCont__icon",
        src: "/assets/img/Icon_Delete.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "deleteCont__name"
      }, intl.format(Action.RemoveLink)))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SphereCastDeleteModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("h3", null, intl.format(SphereCastView.DeleteModalTitle)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ms-auto modal-item"
      }, this.state.Selected ? this.state.Selected.DisplayFileName : "")), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.onDialogClose.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Terminate))), this.state.Selected != null && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default deleteCont",
        onClick: this.deleteSphereCast.bind(this, this.state.Selected.MaterialFileName),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "deleteCont__icon",
        src: "/assets/img/Icon_Delete.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "deleteCont__name"
      }, intl.format(Action.Delete))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SphereCastHelpModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("h3", null, intl.format(SphereCastView.HelpModalTitle)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto modal-description"
      }, /*#__PURE__*/React.createElement("div", null, intl.format(SphereCastView.HelpModalMessage)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.onDialogClose.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Close))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SphereCastEmptyModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("h3", null, intl.format(SphereCastView.EmptyModalTitle)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto modal-description"
      }, /*#__PURE__*/React.createElement("div", null, intl.format(SphereCastView.EmptyModalMessage)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary closeCont",
        onClick: this.onDialogClose.bind(this, true),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "closeCont__icon",
        src: "/assets/img/check_icon_white.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "closeCont__name"
      }, intl.format(Action.Ok))))))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param deviceType デバイス種別
 * @oaram sessionId 会議ID
 * @param host ホスト
 */


export default function (el, common, deviceType, sessionId, host) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    deviceType: deviceType,
    sessionId: sessionId,
    host: host
  }), el);
}